<div class="otp-container">
  <div class="otp-card">
    <h1 class="otp-title">Vérifier votre compte</h1>

    <p class="otp-subtitle">Veuillez saisir le code à 6 chiffres envoyé par SMS/Email</p>

    <div class="otp-inputs" [formGroup]="otpForm">
      <div *ngFor="let control of otpControls.controls; let i = index" class="otp-input-wrapper">
        <input type="text" class="otp-input" maxlength="1" pattern="[0-9]" inputmode="numeric"
          autocomplete="one-time-code" [formControl]="getControl(i)" (input)="handleInput($event, i)"
          (keydown)="handleKeyDown($event, i)" #otpInput />
      </div>
    </div>

    <p class="otp-footer">
      Vous n'avez pas reçu de code ? <a href="#" class="resend-link" (click)="onResend($event)">Renvoyer</a>
    </p>

    <div *ngIf="verificationStatus" class="verification-status" [ngClass]="verificationStatus.type">
      {{ verificationStatus.message }}
    </div>
  </div>
</div>